<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">UPLOAD FSAN NUMBER</span>
        </div>
    </div>
    <div class="card card_content">
        <form [formGroup]="uploadFSANForm">
            <div class="row mt-3">
                <div class="col-xl-3"></div>
                <div class="col-xl-6">
                   <div class="row">
                    <div class="col-xl-8 padd-right-file" style="display: flex;">
                        <mat-form-field appearance="fill" hideRequiredMarker (click)="selectFile()">
                            <mat-label>Upload File</mat-label>
                            <input matInput  id="AttachmentFileName" placeholder="Select Attachment"
                                formControlName="AttachmentFileName" autocomplete="off" specialIsAlphaNumeric class="col-10"
                                autocomplete="off" readonly>
                        </mat-form-field>
                        <div >
                            <button type="button" (click)="selectFile()" *ngIf="isFileSelected"
                                class="badge bg-light-blue image-button">
                                <img src="../../../../assets/Home-Connect/icons/upload-Icon.svg" style="width: 26px;"/>
                            </button>
                            <button type="button" (click)="reset()" *ngIf="!isFileSelected" class="badge bg-light-blue image-button">
                                <img style="filter: invert(1);width: 26px;" src="../../../../assets/Home-Connect/icons/delete.svg" />
                            </button>
                       </div>
                    </div>
                    <div class="col-xl-4" style="height: fit-content;align-self: self-end;">
                        <div class="btn btn-secondary" (click)="SaveAllExcelSheets()">
                            Submit
                        </div>
                    </div>
                   </div>
                </div>
                <div class="col-xl-3"></div>
            </div>
        </form>
    </div>
</div>
